import { createMarkerStore, type MarkerStore } from "./markerStoreFactory";

export type IkTargetStore = MarkerStore;

export const useIkTargetStore = createMarkerStore();

export const useIkMarkerVisible = () => useIkTargetStore((state) => state.markerVisible);
export const useIkMarkerWorld = () => useIkTargetStore((state) => state.markerWorld);
export const useIkTargetActions = () => useIkTargetStore((state) => state.actions);

export const getIkTargetState = () => {
  const { actions, ...state } = useIkTargetStore.getState();
  return state;
};

export const getIkTargetActions = () => useIkTargetStore.getState().actions;
